import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'switch-control',
  templateUrl: './switch-control.component.html',
  styleUrls: ['./switch-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SwitchControlComponent,
    multi: true
  }]
})
export class SwitchControlComponent extends BaseControl {

  @Input() public leftLabel: string = '';
  @Input() public switchClass: string = 'primary-switch';

  constructor() {
    super();
  }

  ngOnInit() {
    if (!this.switchClass || this.switchClass == '') this.switchClass = 'primary-switch';

    setTimeout(() =>
      this.updateValue()
    , 0);
  }

  onWriteValue(value) {
    if (value === true || value === false) return;
    if (+value == 1) this.value = true;
    if (+value == 0) this.value = false;
    if (value == 'true') this.value = true;
    if (value == 'false') this.value = false;
  }

}
